import { Badge, ErrorMessage, Span, Spinner } from "../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../base/types";
import { IControlAttributes } from "../../../../base/models";
import { useTextProperties } from "./TextProperties";

export const DraftTextComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { status, error, properties, draftText } = useTextProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                Text
            </Badge>
            <Span className={className} {...properties} text={draftText}>
                {children}
            </Span>
        </div>)
}